import { Stack } from '@atlaskit/primitives';
import { H5 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { CurrentSupportAvailability } from './CurrentSupportAvailability';
import { ContactCard } from './styles';
import { SupportContactDetails } from './SupportContactDetails';
import { SupportRequest } from './SupportRequest';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SupportContact = props => {
  const {
    supportDetails,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/_jsx(ContactCard, {
    children: /*#__PURE__*/_jsxs(Stack, {
      space: "space.300",
      children: [/*#__PURE__*/_jsx(H5, {
        as: "h3",
        children: "Contact"
      }), /*#__PURE__*/_jsxs(Stack, {
        space: "space.200",
        children: [/*#__PURE__*/_jsx(CurrentSupportAvailability, {
          availability: supportDetails.availability
        }), /*#__PURE__*/_jsx(SupportContactDetails, {
          supportDetails: supportDetails
        }), /*#__PURE__*/_jsx(SupportRequest, {
          supportDetails: supportDetails,
          onSupportLinkClick: onSupportLinkClick
        })]
      })]
    })
  });
};